import { createRoot, hydrateRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import App from 'App';
import { store } from 'store';

// style + assets
import 'assets/scss/style.scss';
import config from './config';
import AppContextContainer from 'context/AppContextContainer';

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const app = (
    <Provider store={store}>
        <BrowserRouter basename={config.basename}>
            <AppContextContainer>
                <App />
            </AppContextContainer>
        </BrowserRouter>
    </Provider>
);

// hydrateRoot when react-snap pre-rendered HTML is present; createRoot otherwise
if (container.hasChildNodes()) {
    hydrateRoot(container, app);
} else {
    createRoot(container).render(app);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
